import React, { useState, useEffect } from "react";
import moment from "moment";
import ReactTooltip from "react-tooltip";
import Loader from "../../../../../../components/loader";
import api from "../../../../../../services/api";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { RiSendPlaneFill } from "react-icons/ri"; // Add this import at the top
import TipTapEditor from "../../../../../../components/TipTapEditor";

export default ({ value, setValue }) => {
  const [comment, setComment] = useState("");
  const [comments, setComments] = useState(value.comments || []);
  const [loading, setLoading] = useState(true);
  const user = useSelector((state) => state.Auth.user);

  const handleSubmit = async (e) => {
    e.preventDefault();
    onAdd(comment);
    setComment("");
  };

  const onAdd = async (e) => {
    try {
      const newComment = { text: e, user_name: user.name, user_id: user._id, user_avatar: user.avatar };
      const newComments = [...comments, newComment];
      const { data } = await api.put(`/notion/${value._id}`, { comments: newComments });
      setValue(data);
      toast.success("Comment added!");
      if (user._id === value.user_id) return;
      await api.post(`/notion/${value._id}/send-comment`, { comment: newComment });
    } catch (error) {
      console.error("Erreur lors de l'envoi de l'email :", error);
    }
  };

  const onDelete = async (id) => {
    const newComments = comments.filter((c) => c._id !== id);
    const { data } = await api.put(`/notion/${value._id}`, { comments: newComments });
    setValue(data);
    toast.success("Comment deleted!");
  };

  const getNotion = async () => {
    try {
      setLoading(true);
      const { data } = await api.get(`/notion/${value._id}`);
      setComments(data.comments || []);
    } catch (e) {
      console.log(e);
    }
    setLoading(false);
  };

  useEffect(() => {
    getNotion();
  }, [value.comments]);

  if (loading) return <Loader />;

  return (
    <div className="flex-grow-0 ">
      <form onSubmit={handleSubmit}>
        <div className="rounded-xl overflow-hidden border border-gray-200">
          <div className="bg-white border-b border-gray-100">
            <TipTapEditor
              buttonList={["bold", "italic", "link", "image", "bulletList", "orderedList", "blockquote", "codeBlock"]}
              values={comment}
              onChange={(e) => setComment(e)}
              placeholder="Share your thoughts..."
            />
          </div>

          <div className="px-3 py-2 bg-gradient-to-r from-gray-50 to-white flex justify-end items-center">
            <button
              type="submit"
              disabled={!comment.trim()}
              className={`px-4 py-1.5 rounded-full flex items-center gap-2 text-sm font-medium transition-all bg-gradient-to-r from-indigo-600 to-blue-500 text-white hover:from-indigo-700 hover:to-blue-600 shadow-sm`}>
              <span>{"Comment"}</span>
              <RiSendPlaneFill className={`h-4 w-4`} />
            </button>
          </div>
        </div>
      </form>
      <hr className="mx-8 my-4 border-gray-200" />
      <div className="flex flex-col gap-y-2 mb-4 overflow-y-auto">
        {(comments || [])
          .sort((a, b) => {
            return new Date(b.created_at) - new Date(a.created_at);
          })
          .map((comment, index) => (
            <div key={index} className="flex flex-col bg-gray-50 p-4 rounded-lg shadow-sm">
              <div className="flex items-start justify-between">
                <div className="flex items-center gap-3">
                  <img src={comment.user_avatar} className="rounded-full w-8 h-8 border-2 border-white shadow-sm" alt={comment.user_name} />
                  <div>
                    <div className="font-medium text-gray-900">{comment.user_name}</div>
                    <div className="text-xs text-gray-500" data-tip data-for={`comment-${comment._id}`}>
                      {moment(new Date(comment.created_at)).fromNow()}
                    </div>
                  </div>
                </div>

                {onDelete && (
                  <button
                    className="text-xs text-gray-400 hover:text-red-500 transition-colors"
                    onClick={() => {
                      if (!window.confirm("Are you sure you want to delete this comment?")) return;
                      onDelete(comment._id);
                    }}>
                    Delete
                  </button>
                )}
              </div>

              <div
                style={{
                  marginTop: "12px",
                  color: "#374151",
                  fontSize: "14px",
                  lineHeight: "1.5",
                }}
                className="comment-content"
                dangerouslySetInnerHTML={{ __html: comment.text }}
              />

              <ReactTooltip id={`comment-${comment._id}`}>
                <span>{new Date(comment.created_at).toLocaleString()}</span>
              </ReactTooltip>
            </div>
          ))}
      </div>
    </div>
  );
};
